import React from 'react';

/**
 * Reusable component for hierarchical path navigation
 * 
 * @param {Array} pathHistory - Array of path items with id, name, and level properties
 * @param {Function} navigateUp - Function to navigate up to the top level
 * @param {Function} navigateToBreadcrumb - Function to navigate to a specific item in the path
 * @param {number} currentLevel - Current hierarchy level
 */
const PathNavigation = ({ 
  pathHistory, 
  navigateUp, 
  navigateToBreadcrumb, 
  currentLevel 
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg shadow-sm mb-6">
      <div className="flex items-center text-base">
        <button 
          onClick={() => navigateUp(1)}
          className={`font-medium text-lg ${currentLevel === 1 ? 'text-blue-600 font-bold' : 'text-gray-600 hover:text-blue-600'}`}
        >
          All Categories
        </button>
        
        {pathHistory.map((item, index) => (
          <React.Fragment key={item.id}>
            <div className="flex items-center mx-2">
              <svg className="h-5 w-5 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <button 
              onClick={() => navigateToBreadcrumb(item)}
              className={`font-medium text-lg ${currentLevel === item.level + 1 ? 'text-blue-600 font-bold' : 'text-gray-600 hover:text-blue-600'}`}
            >
              {item.name}
            </button>
          </React.Fragment>
        ))}
      </div>
      
      <div className="mt-2 text-sm text-gray-500">
        <span>Click on any level to navigate directly to it</span>
      </div>
    </div>
  );
};

export default PathNavigation;